module.exports = __webpack_public_path__ + "static/twitter-a318167e19cdc5bed78b0da150723cac.png";